export enum PaymentProcessStatus {
  INITIALIZED = 'INITIALIZED',
  STARTED = 'STARTED',
  SUCCESSED = 'SUCCESSED',
  FAILED = 'FAILED',
}
